import { render, staticRenderFns } from "./clinicalNutritionGuidance.vue?vue&type=template&id=2ffdda24&"
import script from "./clinicalNutritionGuidance.vue?vue&type=script&lang=js&"
export * from "./clinicalNutritionGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports